export default "__VITE_ASSET__CeEqtt_B__"